export default __webpack_public_path__ + "static/media/no-water-icon.a50d2589.svg";